const models = {
	'App\\Model\\Address': {
		name: '@:entity.address.name',
		icon: '@:entity.address.icon',
		noun: 'The',
		header: 'street',
		filter: true,
	},
	'App\\Model\\Accounts\\Accounts': {
		name: 'Account | Accounts',
		icon: 'fal fa-box-dollar',
		noun: 'The',
	},
	'App\\Model\\Accounts\\Journals': {
		name: 'Journal | Journals',
		icon: 'fas fa-abacus',
		noun: 'The',
	},
	'App\\Model\\Invoices': {
		name: 'Invoice | Invoices',
		icon: 'fal fa-file-invoice',
		noun: 'The',
	},
	'App\\Model\\Reports\\Report': {
		name: '@:entity.report.name',
		icon: '@:entity.report.icon',
		noun: 'The',
	},
	'App\\Model\\Cis\\Cis': {
		name: 'Z.I.S. Note | Z.I.S. Notes',
		icon: 'fa-fw fa-solid fa-comment-lines',
		noun: 'The',
		header: 'id',
		filter: true,
	},
	'App\\Model\\CisType': {
		name: 'Z.I.S. Note Type | Z.I.S. Note Types',
		icon: 'fa-solid fa-tags',
		noun: 'The',
		header: 'id',
		filter: true,
	},
	'App\\Model\\Cis\\CisRecord': {
		name: 'Z.I.S. Note | Z.I.S. Notes',
		icon: 'fa-fw fa-solid fa-comment-lines',
		noun: 'The',
		target: 'a record',
		header: 'id',
	},
	'App\\Model\\Comments': {
		name: 'Comment | Comments',
		icon: 'fa-regular fa-comment',
		noun: 'The',
	},
	'App\\Model\\CraftsmanTask': {
		name: '@:entity.craftsman_task.name',
		icon: 'fa-fw fas fa-toolbox',
		noun: 'The',
		header: 'id',
		filter: true,
	},
	'App\\Model\\CraftsmanTaskBuilding': {
		name: 'Property | Properties',
		icon: 'fas fa-building',
		noun: 'The',
		target: 'a craftsman task',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskPersons': {
		name: 'Contact | Contacts',
		icon: 'fa-fw far fa-address-book',
		noun: 'The',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskPersonTypes': {
		name: 'Craftsman Task Contact Type | Craftsman Task Contact Types',
		icon: 'fa-solid fa-tags',
		noun: 'The',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskPersonContact': {
		name: 'Craftsman Task Contact Person | Craftsman Task Contact People',
		icon: 'fa-fw far fa-address-book',
		noun: 'The',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskProcess': {
		name: 'Craftsman Task Process | Craftsman Task Processes',
		icon: 'fa-fw fal fa-cabinet-filing',
		noun: 'The',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskRecord': {
		name: 'File | Files',
		icon: 'fa-fw fas fa-toolbox',
		noun: 'The',
		target: 'a craftsman task',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskStatus': {
		name: 'Craftsman Task Status | Craftsman Task Statuses',
		icon: 'fa-fw fal fa-tasks-alt',
		noun: 'The',
		header: 'id',
		filter: true,
	},
	'App\\Model\\CraftsmanTaskStatusText': {
		name: 'Status Text | Status Texts',
		icon: 'fa-fw fal fa-info-square',
		noun: 'The',
		header: 'id',
		filter: true,
	},
	'App\\Model\\CraftsmanTaskType': {
		name: 'Craftsman Task Type | Craftsman Task Types',
		icon: 'fa-fw fal fa-tags',
		noun: 'The',
		header: 'id',
		filter: true,
	},
	'App\\Model\\CraftsmanTaskUnit': {
		name: 'Unit | Units',
		icon: 'fa-fw far fa-address-book',
		noun: 'The',
		target: 'a craftsman task',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskCis': {
		name: 'Z.I.S. Note | Z.I.S. Notes',
		icon: 'fa-fw fa-solid fa-comment-lines',
		noun: 'The',
		target: 'a craftsman task',
		header: 'id',
	},
	'App\\Model\\CraftsmanTaskTask': {
		name: 'Reminder | Reminders',
		icon: 'fa-fw fa-solid fa-clipboard-list-check',
		noun: 'The',
		target: 'a craftsman task',
		header: 'id',
	},
	'App\\Model\\Document': {
		name: 'File | Files',
		icon: 'fa-fw fas fa-file',
		noun: 'The',
		header: 'file_notes',
		link: {
			name: 'document',
			params: [{ field: 'id', value: 'id' }],
		},
		filter: true,
	},
	'App\\Model\\DocumentContainer': {
		name: 'Document | Documents',
		icon: 'far fa-book',
		noun: 'The',
		header: 'comment',
		filter: true,
	},
	'App\\Model\\DocumentType': {
		name: 'Document Type | Document Types',
		icon: 'fa-solid fa-tags',
		noun: 'The',
		header: 'type_short',
		filter: true,
	},
	'App\\Model\\DocumentRecord': {
		name: 'Document | Documents',
		icon: 'fa-fw fas fa-file',
		noun: 'The',
		target: 'a record',
		header: 'id',
	},
	'App\\Model\\DocumentCraftsmanTask': {
		name: 'Document | Documents',
		icon: 'fa-fw fas fa-file',
		noun: 'The',
		target: 'a craftsman task',
		header: 'id',
	},
	'App\\Model\\Building': {
		name: 'Property | Properties',
		icon: 'fas fa-building',
		noun: 'The',
		link: {
			name: 'building',
			params: [{ field: 'id', value: 'id' }],
		},
		header: 'search',
		filter: true,
	},
	'App\\Model\\BuildingType': {
		name: 'Property Type | Property Types',
		icon: 'fa-solid fa-tags',
		noun: 'The',
		header: 'short',
		filter: true,
	},
	'App\\Model\\Persons': {
		name: 'Person | People',
		icon: 'fa-fw far fa-address-book',
		noun: 'The',
		header: 'lastname',
		link: {
			name: 'person',
			params: [{ field: 'id', value: 'id' }],
		},
		filter: true,
	},
	'App\\Model\\Notes': {
		name: 'Note | Notes',
		icon: 'fa-fw fa-l fa-notes',
		noun: 'The',
	},
	'App\\Model\\PersonEmail': {
		name: 'Email Address | Email Addresses',
		icon: 'fa-solid fa-envelope',
		noun: 'The',
		header: 'id',
		filter: true,
	},
	'App\\Model\\Roles': {
		name: 'Role Type | Role Types',
		icon: 'fa-solid fa-tags',
		noun: 'The',
		header: 'name',
		link: {
			name: 'rolepermission',
			params: [{ field: 'id', value: 'id' }],
		},
		filter: true,
	},
	'App\\Model\\Roles\\RolePermission': {
		name: 'Role | Roles',
		icon: 'fa-fw fas fa-user-friends',
		noun: 'The',
		header: 'id',
		link: {
			name: 'person',
			params: [{ field: 'person.id', value: 'id' }],
		},
		filter: true,
	},
	'App\\Model\\Phonenumber': {
		name: 'Phone Number | Phone Numbers',
		icon: 'fa-solid fa-phone',
		noun: 'The',
		header: 'number',
		link: {
			name: 'person',
			params: [{ field: 'person.id', value: 'id' }],
		},
		filter: true,
	},
	'App\\Model\\MeterLevelDetection\\DeviceType': {
		name: 'Meter Device Type | Meter Device Types',
		icon: 'fa-solid fa-tags',
		noun: 'The',
		header: 'description',
		filter: true,
	},
	'App\\Model\\MeterLevelDetection\\Type': {
		name: 'Meter Type | Meter Types',
		icon: 'fa-solid fa-tags',
		noun: 'The',
		header: 'description',
		filter: true,
	},
	'App\\Model\\MeterLevelDetection\\Manufacturer': {
		name: 'Meter Manufacturer',
		icon: 'fa-solid fa-industry',
		noun: 'The',
		header: 'description',
		filter: true,
	},
	'App\\Model\\MeterLevelDetection\\Meter': {
		name: 'Meter',
		icon: 'fas fa-tachometer-alt',
		noun: 'The',
		header: 'hp_id',
		link: {
			name: 'meterDetails',
			params: [
				{ field: 'id', value: 'meterId' },
				{ field: 'building_id', value: 'id' },
			],
		},
		filter: true,
	},
	'App\\Model\\MeterLevelDetection\\MeterLevel': {
		name: 'Meter Reading | Meter Readings',
		icon: 'fas fa-tachometer-alt',
		noun: 'The',
		header: 'value',
		link: {
			name: 'meterDetails',
			params: [
				{ field: 'meter.id', value: 'meterId' },
				{ field: 'meter.building_id', value: 'id' },
			],
		},
		filter: true,
	},
	'App\\Model\\Record': {
		name: 'File | Files',
		icon: 'fas fa-folders',
		noun: 'The',
		header: 'id',
		filter: true,
	},
	'App\\Model\\RecordBuilding': {
		name: 'Property | Properties',
		icon: 'fas fa-building',
		noun: 'The',
		target: 'a record',
		header: 'id',
	},
	'App\\Model\\RecordRolePermission': {
		name: 'Person | People',
		icon: 'fa-solid fa-users',
		noun: 'The',
		target: 'a record',
		header: 'id',
	},
	'App\\Model\\RecordUnit': {
		name: 'Unit | Units',
		icon: 'fal fa-building',
		noun: 'The',
		target: 'a record',
		header: 'id',
	},
	'App\\Model\\RecordStatus': {
		name: 'File Status | File Statuses',
		icon: 'fal fa-tasks-alt',
		noun: 'The',
		header: 'id',
	},
	'App\\Model\\Ticket': {
		name: 'Ticket | Tickets',
		icon: 'fas fa-ticket',
		noun: 'The',
		header: 'id',
		filter: true,
	},
	'App\\Model\\TicketType': {
		name: 'Ticket Type | Ticket Types',
		icon: 'fa-fw fal fa-tags',
		noun: 'The',
		header: 'id',
		filter: true,
	},
	'App\\Model\\TicketRecord': {
		name: 'File | Files',
		icon: 'fa-solid fa-folders',
		noun: 'The',
		target: 'a ticket',
		header: 'id',
	},
	'App\\Model\\Tasks\\Task': {
		name: 'Reminder | Reminders',
		icon: 'fa-fw fa-solid fa-clipboard-list-check',
		noun: 'The',
		header: 'id',
		filter: true,
	},
	'App\\Model\\Tasks\\TaskType': {
		name: 'Reminder Type | Reminder Types',
		icon: 'fa-solid fa-tags',
		noun: 'The',
		header: 'id',
		filter: true,
	},
	'App\\Model\\Tasks\\TaskRecord': {
		name: 'Reminder | Reminders',
		icon: 'fa-solid fa-clipboard-list-check',
		noun: 'The',
		target: 'a record',
		header: 'id',
	},
	'App\\Model\\Unit': {
		name: 'Unit | Units',
		icon: 'fa-fw fal fa-building',
		noun: 'The',
		header: 'position',
		link: {
			name: 'unit',
			params: [
				{ field: 'id', value: 'unitId' },
				{ field: 'building_id', value: 'id' },
			],
		},
		filter: true,
	},
	'App\\Model\\Propertymanager': {
		name: 'Property Manager',
		icon: 'fa-solid fa-people-roof',
		noun: 'The',
		header: 'hp_id',
		link: {
			name: 'person',
			params: [{ field: 'person.id', value: 'id' }],
		},
		filter: true,
	},
	'App\\Model\\Team': {
		name: 'Team Member | Team Members',
		icon: 'fa-fw fal fa-chalkboard-teacher',
		noun: 'The',
		header: 'id',
		filter: true,
	},
}

export default models
